import { useTranslation } from 'react-i18next';

import { costCenterExport, type CostCenterStatusFilter } from '@/api/domains/organization/costCenters';
import { useExport } from '@/hooks/ui/useExport';


export interface UseCostCenterExportParams {
  searchText?: string;
  status?: CostCenterStatusFilter;
}

interface UseCostCenterExportResult {
  exportCostCenters: () => Promise<void>;
  isExporting: boolean;
}

export function useCostCenterExport(params: UseCostCenterExportParams): UseCostCenterExportResult {
  const { t: translate } = useTranslation();

  const { onExport: exportCostCenters, isExporting } = useExport({
    exportFn: () => costCenterExport.export({
      searchText: params.searchText,
      status: params.status,
    }),
    successMessage: translate('organization:messages.costCentersExportSuccess'),
    errorMessage: translate('organization:messages.costCentersExportError'),
  });

  return { exportCostCenters, isExporting };
}

export default useCostCenterExport;
